export const GLOBAL_BOOLEANS = ["json", "help", "quiet"] as const;
